import axios from 'src/api/client/axios'
import {
  ChannelAuxList,
  EnvironmentDataAuxList,
  HotelAuxList,
  RoomAuxList,
  RoomTypeAuxList,
  RoomTypeCapacityAuxList,
  ZoneAuxList
} from 'src/api'

export type ApiGetUserEnvironmentDataDemandType = (
  'entornos'|
  'zonas'|
  'establecimientos'|
  'tipos_alojamientos'|
  'alojamientos'|
  'canales'|
  'capacidades_tipos_alojamientos')

export interface ApiGetUserEnvironmentDataParamsData {
  userToken: string
  environmentDataId: string
  dataDemandList: ApiGetUserEnvironmentDataDemandType[]
}

export interface ApiGetUserEnvironmentDataParams {
  serverPath: string
  data: ApiGetUserEnvironmentDataParamsData
  controller?: AbortController
}

export interface ApiGetUserEnvironmentDataResponse {
  environmentDataAuxList: EnvironmentDataAuxList[]
  zoneAuxList: ZoneAuxList[]
  hotelAuxList: HotelAuxList[]
  roomTypeAuxList: RoomTypeAuxList[]
  roomAuxList: RoomAuxList[]
  roomTypeCapacityAuxList: RoomTypeCapacityAuxList[]
  channelAuxList: ChannelAuxList[]
}

export const ApiGetUserEnvironmentData = async ({ serverPath, data, controller }:ApiGetUserEnvironmentDataParams) => {
  const res = await axios.post<ApiGetUserEnvironmentDataResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/getuserenvironmentdata`, data, {
    signal: controller?.signal
  })
  return res.data
}
